import * as yup from "yup";

const referralSchema = yup.object({
	email: yup
		.string()
		.trim()
		.lowercase()
		.email("Please enter a valid email address")
		.required("Email is required"),
});

export default referralSchema;
